// src/components/BonusPresets.js
export const BONUS_PRESETS = [
  // --- SHOW SETTIMANALI ---
  { label: "Vince sett.", cat: "sett", values: ["match_sett", "vince_sett"] },
  { label: "Vince 3-6 sett.", cat: "sett", values: ["match_sett", "vince_match_3_6"] },
  { label: "Vince >6 sett.", cat: "sett", values: ["match_sett", "vince_match_6_plus"] },
  { label: "Perde opp. titolata", cat: "sett", values: ["match_sett", "opp_titolata"] },
  { label: "Vince titolo MAX", cat: "sett", values: ["match_sett", "opp_titolo", "vince_sett", "vince_titolo_massimo"] },
  { label: "Vince titolo SINGOLO", cat: "sett", values: ["match_sett", "opp_titolata_mondiale", "vince_sett", "vince_titolo_singolo"] },
  { label: "Vince titolo TAG", cat: "sett", values: ["match_sett", "opp_titolata", "vince_sett", "vince_titolo_tag"] },
  { label: "Mantiene titolo", cat: "sett", values: ["match_sett", "vince_sett", "mantiene_titolo"] },

  // --- PLE STANDARD ---
  { label: "Vince PLE", cat: "ple", values: ["match_ple", "vince_ple"] },
  { label: "Opener (perde)", cat: "ple", values: ["match_ple", "opener"] },
  { label: "Opener (vince)", cat: "ple", values: ["match_ple", "opener", "vince_ple"] },
  { label: "ME (perde)", cat: "ple", values: ["match_ple", "main_event"] },
  { label: "ME (vince)", cat: "ple", values: ["match_ple", "main_event_ple", "vince_ple"] },

  // --- PLE SPECIALI ---
  { label: "Rumble Win", cat: "ple", values: ["match_ple", "vince_royal_rumble", "stipulazione_speciale", "eliminazione", "vince_match_6_plus_ple", "n1_contender"] },
  { label: "MITB Win", cat: "ple", values: ["match_ple", "vince_mitb", "stipulazione_speciale", "vince_match_6_plus_ple"] },
  { label: "K/Q Ring Win", cat: "ple", values: ["match_ple",'vince_ple', "vince_kor"] },
  { label: "Vince WM ME", cat: "ple", values: ["match_ple", 'vince_ple', "main_event_wm"] },

  // --- VITTORIE TITOLATE ---
  { label: "Titolo max", cat: "ple", values: ["match_ple", "vince_ple", "opp_titolata_mondiale", "vince_titolo_massimo"] },
  { label: "Titolo sing.", cat: "ple", values: ["match_ple", "vince_ple", "opp_titolata", "vince_titolo_singolo"] },
  { label: "Titolo tag", cat: "ple", values: ["match_ple", "vince_ple", "opp_titolata", "vince_titolo_tag"] },
  { label: "Mant. titolo", cat: "ple", values: ["match_ple", "vince_ple", "mantiene_titolo"] },

  // --- MALUS ---
  { label: "Count out PLE", cat: "ple", values: ["match_ple", "count_out"] },
  { label: "Pareggio", cat: "ple", values: ["match_ple", "pareggio"] },
  { label: "Botch", cat: "ple", values: ["match_ple", "botch"] },

  // --- EXTRA ---
  { label: "Entrata spec.", cat: "ple", values: ["match_ple", "entrata_speciale"] },
  { label: "Interferenza", cat: "ple", values: ["interferenza_ple"] },
  { label: "Spacca ogg.", cat: "ple", values: ["match_ple", "spacca_oggetto"] },
  { label: "Coro", cat: "both", values: ["coro"] },

  /*
// src/components/BonusPresets.js
export const BONUS_PRESETS = [
  // --- SHOW SETTIMANALI (SETT) ---
  { label: "Vince match sett.", cat: "sett", values: ["match_sett", "vince_sett"] },
  { label: "Main Event (perde)", cat: "sett", values: ["match_sett", "main_event"] },
  { label: "Main Event (vince)", cat: "sett", values: ["match_sett", "main_event", "vince_sett"] },
  { label: "Vince 3-6 wrestler", cat: "sett", values: ["match_sett", "vince_match_3_6"] },
  { label: "Vince 6+ wrestler", cat: "sett", values: ["match_sett", "vince_match_6_plus"] },
  { label: "Vince con roll-up", cat: "sett", values: ["match_sett", "vince_sett", "roll_up_win"] },

  // --- OPPORTUNITÀ TITOLATE SETT ---
  { label: "Opportunità titolata (perde)", cat: "sett", values: ["match_sett", "opp_titolata"] },
  { label: "Opportunità titolata mondiale (perde)", cat: "sett", values: ["match_sett", "opp_titolata_mondiale"] },
  { label: "Vince titolo SINGOLO", cat: "sett", values: ["match_sett", "opp_titolata", "vince_sett", "vince_titolo_singolo"] },
  { label: "Vince titolo TAG TEAM", cat: "sett", values: ["match_sett", "opp_titolata", "vince_sett", "vince_titolo_tag"] },
  { label: "Vince titolo MONDIALE", cat: "sett", values: ["match_sett", "opp_titolata_mondiale", "vince_sett", "vince_titolo_massimo"] },
  { label: "Difende titolo", cat: "sett", values: ["match_sett", "opp_titolata", "vince_sett", "mantiene_titolo"] },
  { label: "Difende titolo mondiale", cat: "sett", values: ["match_sett", "opp_titolata_mondiale", "vince_sett", "mantiene_titolo"] },
  { label: "Doppio campione", cat: "sett", values: ["match_sett", "opp_titolata", "vince_sett", "doppio_campione"] },

  // --- PLE STANDARD ---
  { label: "Vince PLE", cat: "ple", values: ["match_ple", "vince_ple"] },
  { label: "Opener PLE (perde)", cat: "ple", values: ["match_ple", "opener"] },
  { label: "Opener PLE (vince)", cat: "ple", values: ["match_ple", "opener", "vince_ple"] },
  { label: "Main Event PLE (perde)", cat: "ple", values: ["match_ple", "main_event_ple"] },
  { label: "Main Event PLE (vince)", cat: "ple", values: ["match_ple", "main_event_ple", "vince_ple"] },
  { label: "Solo apparizione PLE", cat: "ple", values: ["apparizione_ple"] },
  { label: "Entrata speciale PLE", cat: "ple", values: ["match_ple", "entrata_speciale"] },
  { label: "Interferenza attiva PLE", cat: "ple", values: ["interferenza_ple"] },
  { label: "Spacca oggetto PLE", cat: "ple", values: ["match_ple", "spacca_oggetto"] },

  // --- VITTORIE MULTIPLE PLE ---
  { label: "Vince 3-4 PLE", cat: "ple", values: ["match_ple", "vince_match_3_4_ple"] },
  { label: "Vince 5-6 PLE", cat: "ple", values: ["match_ple", "vince_match_5_6_ple"] },
  { label: "Vince 6+ PLE", cat: "ple", values: ["match_ple", "vince_match_6_plus_ple"] },

  // --- PLE SPECIALI (RUMBLE/MITB/KOR) ---
  { label: "Royal Rumble (partecipa)", cat: "ple", values: ["match_ple"] },
  { label: "Royal Rumble WIN", cat: "ple", values: ["match_ple", "vince_royal_rumble"] },
  { label: "Royal Rumble Runner-up", cat: "ple", values: ["match_ple", "runner_up"] },
  { label: "Eliminazione RR", cat: "ple", values: ["match_ple", "eliminazione"] },
  { label: "Money In The Bank WIN", cat: "ple", values: ["match_ple", "vince_mitb"] },
  { label: "King/Queen of Ring WIN", cat: "ple", values: ["match_ple", "vince_kor"] },

  // --- OPPORTUNITÀ TITOLATE PLE ---
  { label: "Opportunità titolata PLE (perde)", cat: "ple", values: ["match_ple", "opp_titolata"] },
  { label: "Opportunità titolata mondiale PLE (perde)", cat: "ple", values: ["match_ple", "opp_titolata_mondiale"] },
  { label: "Vince titolo SINGOLO PLE", cat: "ple", values: ["match_ple", "opp_titolata", "vince_ple", "vince_titolo_singolo"] },
  { label: "Vince titolo TAG PLE", cat: "ple", values: ["match_ple", "opp_titolata", "vince_ple", "vince_titolo_tag"] },
  { label: "Vince titolo MONDIALE PLE", cat: "ple", values: ["match_ple", "opp_titolata_mondiale", "vince_ple", "vince_titolo_massimo"] },
  { label: "Difende titolo PLE", cat: "ple", values: ["match_ple", "opp_titolata", "vince_ple", "mantiene_titolo"] },

  // --- WRESTLEMANIA SPECIAL ---
  { label: "Wrestlemania Main Event", cat: "ple", values: ["match_ple", "main_event_wm"] },
  { label: "Wrestlemania Main Event (vince)", cat: "ple", values: ["match_ple", "main_event_wm", "vince_ple"] },
  { label: "Vince titolo a WM", cat: "ple", values: ["match_ple", "main_event_wm", "vince_ple", "vince_titolo_massimo"] },

  // --- BONUS ESTREMI/SPETTACOLARI ---
  { label: "Fa sanguinare avversario", cat: "ple", values: ["match_ple", "sanguinamento"] },
  { label: "Botch", cat: "ple", values: ["match_ple", "botch"] },
  { label: "Vittoria per roll-up PLE", cat: "ple", values: ["match_ple", "vince_ple", "roll_up_ple"] },

  // --- MALUS PLE ---
  { label: "Voto basso PLE (<=2)", cat: "ple", values: ["match_ple", "voto_basso"] },
  { label: "Voto alto PLE (>=4)", cat: "ple", values: ["match_ple", "voto_alto"] },
  { label: "Pareggio PLE", cat: "ple", values: ["match_ple", "pareggio"] },;


  */
];
